var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Discount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-discount",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M13.251,20a.747.747,0,0,1-.53-.219l-.89-.89,7.581-7.57A2.012,2.012,0,0,0,20,9.9V4h.88a1.052,1.052,0,0,1,.71.291l.12.12a1.047,1.047,0,0,1,.29.71V9.9a4.017,4.017,0,0,1-1.22,2.88l-7,7A.744.744,0,0,1,13.251,20ZM9.486,18a1,1,0,0,1-.706-.291L.291,9.22a1,1,0,0,1,0-1.409L7.511.59A2.017,2.017,0,0,1,8.931,0h7.95a1.047,1.047,0,0,1,.71.29l.121.121A1.042,1.042,0,0,1,18,1.12V9.07a2.017,2.017,0,0,1-.59,1.42l-7.22,7.22A.993.993,0,0,1,9.486,18ZM8.931,2h0L2.411,8.51,9.491,15.59,16,9.07V2H8.931ZM12,8a2,2,0,1,1,2-2A2,2,0,0,1,12,8Z",
    transform: "translate(0.999 2)",
    fill: "#02466a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Discount);
export default __webpack_public_path__ + "static/media/icon-24-discount.ccd528eea65adaf12fc75e97ac8be282.svg";
export { ForwardRef as ReactComponent };